module.exports = __webpack_public_path__ + "static/media/image.8b5d552a.png";